export default "__VITE_ASSET__ofaPFvlA__"